export * from './compare-pipe';
export * from './date-between-pipe';
export * from './find-in-pipe';
export * from './order-pipe';
export * from './safehtml-pipe';
export * from './date-time-pipe';
export * from './to-number-pipe';
export * from './reverse-pipe';
export * from './currency-format-pipe';
export * from './set-comma-pipe';



// WEBPACK FOOTER //
// ./src/app/pipes/index.ts